import { render, staticRenderFns } from "./GroupSalesmanTable.vue?vue&type=template&id=33234da0&scoped=true"
import script from "./GroupSalesmanTable.vue?vue&type=script&lang=js"
export * from "./GroupSalesmanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33234da0",
  null
  
)

export default component.exports